import script from "./OmniFaceTool.vue?vue&type=script&setup=true&lang=js"
export * from "./OmniFaceTool.vue?vue&type=script&setup=true&lang=js"

import "./OmniFaceTool.vue?vue&type=style&index=0&id=3eacdb7d&scoped=true&lang=css"
import "./OmniFaceTool.vue?vue&type=style&index=1&id=3eacdb7d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eacdb7d"]])

export default __exports__